import React from 'react';
import { Link } from 'gatsby';
import Button from './Button';

export default function EmbeddedTemplate({
  slug,
  title,
  cta = '',
  lazy = true,
  height = 500,
  description,
}) {
  const src = `/templates/${slug}?_noga=1&title=${encodeURIComponent(
    title,
  )}&cta=${encodeURIComponent(cta)}&embedded=1`;

  return (
    <div>
      <div
        className="flex flex-col gap-y-2 md:flex-row md:items-center bg-midnight mb-6 rounded-[8px] text-white min-h-[100px] px-5 pt-2 pb-4 md:pb-2"
        style={{
          backgroundImage: 'url(/website/logo-v3/graphics/4-7.svg)',
          backgroundPosition: 'bottom -150px right 0px',
          backgroundSize: '50% 400px',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="flex-1">
          <h3 className="text-sm !leading-8 capitalize !my-0">
            {title || slug.split('-').join(' ')}
          </h3>
          {description && (
            <p className="hidden md:visible text-xs text-white/70 line-clamp-2">
              {description}
            </p>
          )}
        </div>

        <div className="flex justify-center mr-auto md:mr-0">
          <Button to={`/templates/${slug}`} solid yellow>
            {cta || 'Get Started'}
          </Button>
        </div>
      </div>

      <div className="flex items-center justify-center bg-black/[0.03] p-7">
        <Link to={`/templates/${slug}/`} className="_template">
          <iframe
            title={title}
            src={lazy ? null : src}
            data-src={src}
            className={lazy ? 'lozad' : ''}
            frameBorder={0}
            style={{ border: '1px solid #ddd', height, maxHeight: '80vh' }}
          />
        </Link>
      </div>
    </div>
  );
}
